import { Collapse, Row, Col, Button } from "antd";
import React from "react";
import { Helmet } from "react-helmet";
import { SVGicon } from "./SVGicon/SVGicon";
import { StyledTabsSHB } from "./StyleComponent/StyledTabsSHB/StyledTabsSHB";
import { StyledInputSHB } from "./StyleComponent/StyledInputSHB/StyledInputSHB";
import { StyledAvatarSHB } from "./StyleComponent/StyledAvatarSHB/StyledAvatarSHB";
import { StyledButtonSHB } from "./StyleComponent/StyledButtonSHB/StyledButtonSHB";
import { StyledColorsSHB } from "./StyleComponent/StyledColorsSHB/StyledColorsSHB";
import { StyledSwitchSHB } from "./StyleComponent/StyledSwitchSHB/StyledSwitchSHB";
import { StyledDropDownSHB } from "./StyleComponent/StyledDropDownSHB/StyledDropDownSHB";
import { StyledTypographySHB } from "./StyleComponent/StyledTypographySHB/StyledTypographySHB";
import { StyledModalSHB } from "./StyleComponent/StyledModalSHB/StyledModalSHB";
import "./StyleGuide.css";

const { Panel } = Collapse;

const StyleGuideCollapsible = [
  { collapsibleHead: "Colors", collapsibleComp: <StyledColorsSHB /> },
  { collapsibleHead: "Typography", collapsibleComp: <StyledTypographySHB /> },
  { collapsibleHead: "Button", collapsibleComp: <StyledButtonSHB /> },
  { collapsibleHead: "Form Inputs", collapsibleComp: <StyledInputSHB /> },
  { collapsibleHead: "Drop Down", collapsibleComp: <StyledDropDownSHB /> },
  { collapsibleHead: "Tabs", collapsibleComp: <StyledTabsSHB /> },
  { collapsibleHead: "Switch", collapsibleComp: <StyledSwitchSHB /> },
  { collapsibleHead: "Avatar", collapsibleComp: <StyledAvatarSHB /> },
  { collapsibleHead: "Breadcrumbs", collapsibleComp: <StyledButtonSHB /> },
  { collapsibleHead: "Modal", collapsibleComp: <StyledModalSHB /> },
];

export const StyleGuide = () => {
  const onChange = (key) => {
    console.log(key);
  };

  return (
    <>
      <Helmet>
        <title>Style Guide | Metropolis</title>
      </Helmet>
      <main>
        <section className="styleGuideBody ground-color-berry py-10">
          <div className="section-header-lg sector-sign-up-free-profile-header mb-10">
            <h2 className="section-header-lg-primary-heading text-color-white fw-700">Metropolis Style Guide</h2>
            <p className="section-header-lg-secondary-text text-color-white fw-400 mt-0">
              Element component has been designed for easy pick to use.
            </p>
          </div>

          <div className="mtp-container">
            <Row gutter={[16, 16]}>
              <Col xs={24}>
                <div className="mtp-accordion-item-wrapper">
                  <Collapse
                    accordion
                    defaultActiveKey={["1"]}
                    onChange={onChange}
                    expandIcon={({ isActive }) => (isActive ? <>{SVGicon.plusIcon}</> : <>{SVGicon.minusIcon}</>)}
                  >
                    {StyleGuideCollapsible.map((guideItems, guideIndex) => (
                      <Panel header={guideItems.collapsibleHead} key={guideIndex + 1} arrow="right">
                        {guideItems.collapsibleComp}
                      </Panel>
                    ))}
                  </Collapse>
                </div>
              </Col>
            </Row>
          </div>
        </section>
      </main>
    </>
  );
};
